import {disableScroll, enableScroll} from '../../utils/helpers/scroll';

const sortByValues = () => {
    const siteBlog = document.querySelector('.site-blog');
    const pageURL = siteBlog.getAttribute('data-url');
    const selectSortByValue = document.querySelector('select#sortBy');
    const selectSortByCategory = document.querySelector('select#sortByCategory');
    const overlay = document.querySelector('.loading-overlay');
    let postsArr = [];

    $('select.js-custom-select').on('change', function ({target}) {
        const items = document.querySelectorAll('.blog-post');
        const dataPage = siteBlog.getAttribute('data-page');
        postsArr = [];

        items.forEach(item => {
            postsArr.push(item.getAttribute('data-post-id'));
        });

        target.dataset.sort === 'categories' ? siteBlog.setAttribute('data-page', 1) : '';

        let data = {
            action: "deliverly_ajax_sort_by",
            pageNum: dataPage,
            posts: postsArr,
            sort: target.dataset.sort,
        };

        selectSortByValue ? data.valueSort = selectSortByValue.value : '';
        selectSortByCategory ? data.valueCat = selectSortByCategory.value : '';

        target.dataset.sort === 'categories' ? history.pushState({}, '', pageURL) : '';

        $.ajax({
            url: themeVars.ajaxurl,
            data: data,
            type: "POST",

            beforeSend: function () {
                overlay.classList.add('active');
                disableScroll();
            },

            success: function (data) {
                if (data) {
                    overlay.classList.remove('active');
                    enableScroll();
                    const itemsWrapper = document.querySelector('.blog-articles-wrapper');
                    itemsWrapper.innerHTML = data;
                }
            },
        });
    });
}

export default sortByValues;